var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStoriesShareLinkedin = function SvgStoriesShareLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M7 22H2V9h5zM4.49 7h-.029C2.95 7 1.973 5.818 1.973 4.519c0-1.329 1.008-2.412 2.547-2.412 1.541 0 2.488 1.118 2.519 2.447C7.038 5.854 6.061 7 4.49 7ZM16 13a2 2 0 0 0-2 2v7H9s.059-12 0-13h5v1.485s1.548-1.443 3.938-1.443C20.9 9.042 23 11.186 23 15.346V22h-5v-7a2 2 0 0 0-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h24v24H.5z"
  }))));
};
export default SvgStoriesShareLinkedin;